import { StateEnum } from "../../../Models/Bases/StateEnum";
import { BaseService } from "../../Bases/BaseService";
import { ValidationResponse } from "../../Bases/ValidationResponse";

export class UsuarioTecnologiaService extends BaseService {
    public selecionarValidos(usuarioTecnologias: any) {
        return usuarioTecnologias?.filter((e: any) => e.state != StateEnum.Deleted);
    }

    public salvar(usuarioTecnologia: any, usuarioTecnologias: any) {
        if (!this.numberIsFilled(usuarioTecnologia.tecnologia_id) ) {
            return new ValidationResponse(null, 'Preencha o campo Tecnologia!');
        }

        let validation = usuarioTecnologias?.filter(
            (e: any) =>
                usuarioTecnologia.id != e.id &&
                usuarioTecnologia.tecnologia_id == e.tecnologia_id &&
                e.state != StateEnum.Deleted);

        if (validation.length > 0) {
            return new ValidationResponse(null, 'Tecnologia já inserida!');
        }

        let ids = usuarioTecnologias?.map((x: any) => x.id) ?? [];
        let min = Math.min.apply(null, ids);
        usuarioTecnologia.id = min > 0 ? -1 : min - 1;
        usuarioTecnologia.state = StateEnum.Inserted;
        usuarioTecnologias = usuarioTecnologias.concat(usuarioTecnologia);

        return new ValidationResponse(usuarioTecnologias);
    }

    public apagar(id: number, usuarioTecnologias: any) {
        if (id > 0) {
            usuarioTecnologias.forEach((e: any) => e.state = (e.id == id ? StateEnum.Deleted : e.state));
        }
        else {
            usuarioTecnologias = usuarioTecnologias?.filter((e: any) => e.id != id);
        }

        return new ValidationResponse(usuarioTecnologias);
    }
}